import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
	selector: 'sm-control-wrapper',
	template: `<div class="form-group" [ngClass]="{'has-danger': hasDanger}" *ngIf="control">
					<label [htmlFor]="labelFor" class="form-control-label" i18n>{{label}}<span *ngIf="required" class="text-danger ml-1">*</span></label>
					<ng-content></ng-content>
					<sm-control-messages [customErrorMessage]="customErrorMessage" [control]="control" [checkDirty]="checkDirty"></sm-control-messages>
				</div>`
})
export class ControlWrapperComponent {
	@Input() control: AbstractControl;
	@Input() required: boolean = false;
	@Input() label: string = '';
	@Input() checkDirty: boolean = true;
	@Input('label-for') labelFor: string = '';
	@Input() customErrorMessage: string;

	get hasDanger() {
		return this.control && this.control.invalid && (!this.checkDirty || this.control.dirty) && this.control.enabled;
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/components/sm-control-wrapper.component.ts